import ChangesWithoutSaveModal from "./components/ChangesWithoutSaveModal/ChangesWithoutSaveModal"
import NewEditTemplateCollectionBody from "./components/NewEditTemplateCollectionBody/NewEditTemplateCollectionBody"
import NewEditTemplateCollectionHeader from "./components/NewEditTemplateCollectionHeader/NewEditTemplateCollectionHeader"
import { NewEditTemplateCollectionProvider } from "./context/NewEditTemplateCollectionContext"

const NewEditTemplateCollectionPage = () => {

  return (
    <NewEditTemplateCollectionProvider>
      <section className="section-wrapper">
        <NewEditTemplateCollectionHeader />
        <NewEditTemplateCollectionBody />
        <ChangesWithoutSaveModal />
      </section>
    </NewEditTemplateCollectionProvider>
  )
}

export default NewEditTemplateCollectionPage
